import { ClipLoader } from 'react-spinners';
import { config } from '~/config';

// NOTE: 親のコンポーネントが 100% の高さかつ position: relative な親要素を持っている必要がある

type Props = {
  loading?: boolean;
  loadingText?: string;
};
export const Loading = (props: Props) => {
  const dots = "d4q1i9p";
  if (!props.loading) return null;
  return <div className="fixed inset-0 bg-[#222222B2] z-50">
      <div className="fixed inset-0 m-auto w-44 h-44 bg-white rounded-md">
        <div className="flex flex-col gap-4 justify-center items-center h-full">
          <img src={config.loadingImageUrl.main} alt="Loading..." className="animate-loadingIcon" />
          <p className={`text-center font-bold text-black ${dots}`}>
            {props.loadingText ?? 'Loading'}
          </p>
        </div>
      </div>
    </div>;
};
export const InfiniteScrollLoader = () => {
  return <div className="w-full py-3 flex justify-center">
      <ClipLoader color="#999" loading size={16} aria-label="Loading Spinner" />
    </div>;
};
export const ListContentLoader = () => {
  return <div className="flex justify-center items-center py-12">
      <ClipLoader color="#999" loading size={16} aria-label="Loading Spinner" />
    </div>;
};
export const NumberLoader = () => {
  return <ClipLoader color="#999" size={12} loading aria-label="Loading Spinner" />;
};

require("./Loading.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Loading.tsx");